export const CAR_DIFF_PATHS_TO_OMIT = ['hash', 'image', 'symbol', 'assignedDriver'];

// Each entry hides any path segment that STARTS WITH it, so 'driversLicense'
// covers the whole family (driversLicenseNumber, driversLicenseState, …).
export const SENSITIVE_DIFF_PATHS_TO_OMIT = [
  'ssn',
  'dob',
  'dateOfBirth',
  'driversLicense',
  'savedDriversLicense',
  'driverLicense'
];

const SENSITIVE_PREFIXES = SENSITIVE_DIFF_PATHS_TO_OMIT.map((field) => field.toLowerCase());

export const isSensitiveField = (field) => {
  const lowered = String(field).toLowerCase();
  return SENSITIVE_PREFIXES.some((prefix) => lowered.startsWith(prefix));
};

export const OFFER_DIFF_PATTERNS_TO_OMIT = [
  /^quote\.buyUp(\.|$)/i,
  /insuranceScore\.steps/i,
  /^offerings\.\d+\.(kind|name)$/i
];

// True when a flattened diff path (e.g. 'quote.drivers.0.dateOfBirth') should be
// omitted. The sensitive list and noise patterns above always apply;
// extraPathsToOmit are feature-specific entries matched as case-insensitive substrings.
export const containsOmittedPath = (path, extraPathsToOmit = []) => {
  const lowerPath = path.toLowerCase();
  const segments = lowerPath.split('.');
  if (segments.some(isSensitiveField)) {
    return true;
  }
  if (OFFER_DIFF_PATTERNS_TO_OMIT.some((pattern) => pattern.test(path))) {
    return true;
  }
  return extraPathsToOmit.some((omit) => lowerPath.includes(omit.toLowerCase()));
};
